// Client-side read access to Deal.Builders_Risk_Data (JSON-shaped long-text
// field). The authoritative schema + validator live server-side at
// utils/builders-risk-schema.js; the V2 app only DISPLAYS the blob, so this
// stays a tolerant parse — bad or missing blobs return null and the property
// panels render their empty states instead of crashing the workspace.
export function parseBrData(raw) {
  if (!raw) return null;
  if (typeof raw === 'object') return raw;
  if (typeof raw !== 'string') return null;
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

// Human word for the BR_Status pill/META (BrStatusPanel owns the full pill
// UI; this is the one-word form for header META and rail chips).
export function brStatusWord(status) {
  switch (status) {
    case 'requested': return 'Signature pending';
    case 'bound': return 'Signed';
    case 'not_requested': return 'Not sent';
    default: return status || null;
  }
}
